"use strict";

define('layout/legacy.layout',['marionette', '../templates'], function (Mn, Templates) {
  var LegacyLayout = Mn.LayoutView.extend({
    template: Templates.IRB['legacy.layout'],
    regions: {
      legacy: '.legacy',
      sidebar: '.sidebar',
      main: '.main',
      dimmer: '.legacyDimmer',
      notifications: '#notifications'
    }
  });
  return LegacyLayout;
});

